
import { CREATE_UPDATE, CREATE_UPDATE_QUEUE_CHECK, VERIFIED_ORDER_LOGS, SELECTED_PARTS, FETCH_DL_EMAIL_BY_REGION } from "./actionsTypes";
import { apiStart, apiError, apiSuccess } from "./apiActions";
import { createUpdateEnquiryService } from "../../services/createUpdateEnquiry.service ";
import { getUniqueTimestamp } from "../../common/components/util";

export const createUpdateEnquiryActions = {
  createEnquiry,
  updateEnquiry,
  getEnquiryDetails,
  getRefreshOrderDetailsAPI,
  deleteInvalidParts,
  resetEnquiryInfo,
  getTBLPartsAPI,
  // getTechDocPartList
  getLossSaleReasonList,
  postLossSaleReasonList,
  sendEmailWihtoutAnnexurePlaceOrder,
  sendEmailInvalidAnnexureQuantity,
  notifyFSEPricingTeamOrderPlace
};

export function getUniqueEnquirySessionId(enquirySessionId: any) {
  return async (dispatch: any) => {
    dispatch(apiSuccess(CREATE_UPDATE.GET_UNIQUE_ENQUIRY_ID, enquirySessionId));
    return enquirySessionId || {};
  };
}

export function resetEnquiryInfo() {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.RESET_ENQUIRY_INFO));
  };
}


export function createEnquiry(customerTierType: any, customerAccountType: any, reference: any, products: any, isAnnexureEnquiry?: any, userName?: any, userId?: any, enquirySessionId?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CREATE_UPDATE_FETCHING));
    // let sessionId = enquirySessionId && enquirySessionId.toString();
    let sessionId = !enquirySessionId ? getUniqueTimestamp() : enquirySessionId && enquirySessionId.toString();
    try {
      let sendData = {
        "masterReferenceNumber": reference,
        "products": products,
        "customerId": sessionStorage.getItem('customerId'),
        "customerName": sessionStorage.getItem('customerName'),
        "sessionDetails": {
          "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
          "clientIPAddress": sessionStorage.getItem('clientIp'),
        },
        "dealerCode": "test01",
        "userName": userName,
        "userId": userId,
        userRole: sessionStorage.getItem('userType') === 'sre' ? 'SRE' : '',
        isAnnexureEnquiry: isAnnexureEnquiry ? isAnnexureEnquiry : false,
        enquirySessionId: sessionId && sessionId.length > 6 ? `b2bLSR${sessionId}` : `b2bLSR${getUniqueTimestamp()}`,
        customerType: customerTierType.toLowerCase(),
        customerAccountType: customerAccountType,
      }
      const response = await createUpdateEnquiryService.createEnquiry(sendData);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CREATE_UPDATE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CREATE_UPDATE_ERROR, error));
      return error;
    }
  };
}

export function updateEnquiry(customerTierType: any, shiftToPartyCustomerNumber: any, masterId: any, products: any, isCostUpdate: any, insertData?: any, enquiryNumber?: any, enquirySessionId?: any, isConfirmation?: any, isQuotation?: any, comment?: any, b2bUserId?: any, isTpcDealer?: any, isAnnexureEnquiry?: any) {
  let sessionId = enquirySessionId && enquirySessionId.toString();
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CREATE_UPDATE_FETCHING));
    try {
      let sendData: any = {
        "updateData": products,
        "sessionDetails": {
          "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
          "clientIPAddress": sessionStorage.getItem('clientIp'),
          "loginPassword": "",
          "applicationSecurityKey": "",
          "initialLogonIndicator": "",
          "initialPassword": "",
          "username": "",
          "password": ""
        },
        isAnnexureEnquiry: isAnnexureEnquiry ? isAnnexureEnquiry : false,
        "insertData": insertData && Array.isArray(insertData) ? insertData : [],
        "isCostUpdate": isCostUpdate,
        "isConfirmation": isConfirmation ? true : false,
        "enquiryNumber": enquiryNumber,
        "customerId": sessionStorage.getItem('customerId'),
        "customerName": sessionStorage.getItem('customerName'),
        userRole: sessionStorage.getItem('userType') === 'sre' ? 'SRE' : '',
        customerType: customerTierType && customerTierType.toLowerCase(),
        shiftToPartyCustomerNumber: shiftToPartyCustomerNumber,
        "enquirySessionId": sessionId && sessionId.includes('b2bLSR') ? enquirySessionId : `b2bLSR${enquirySessionId}`,
      }

      if (isTpcDealer) {
        sendData.isTpcDealer = true;
      }
      if (isQuotation) {
        sendData.isQuotation = true;
        sendData.quotationComment = comment;
        if (sessionStorage.getItem('userType') === 'FSE') {
          sendData.quotationToDate = sessionStorage.getItem('validUntilDate');
        }
        sendData.b2bUserId = b2bUserId;
      }
      const response = await createUpdateEnquiryService.updateEnquiry(masterId, sendData);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CREATE_UPDATE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CREATE_UPDATE_ERROR, error));
      return error;
    }
  };
}

export function verifyEnquiry(customerTierType: any, masterId: any, enquirySessionId: any, isAddToEnquiry?: any) {
  let sessionId = enquirySessionId && enquirySessionId.toString();
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CREATE_UPDATE_FETCHING));
    try {
      let sendData: any = {
        "sessionDetails": {
          "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
          "clientIPAddress": sessionStorage.getItem('clientIp'),
          "loginPassword": "",
          "applicationSecurityKey": "",
          "initialLogonIndicator": "",
          "initialPassword": "",
        },
        customerType: customerTierType && customerTierType.toLowerCase(),
        customerId: sessionStorage.getItem('customerId'),
        userRole: sessionStorage.getItem('userType') === 'sre' ? 'SRE' : '',
        isTierEnquiry: isAddToEnquiry === false ? true : false,
        enquirySessionId: sessionId && sessionId.includes('b2bLSR') && sessionId.length > 6 ? sessionId : sessionId !== null && sessionId.length > 5 ? `b2bLSR${sessionId}` : `b2bLSR${getUniqueTimestamp()}`,
        // enquirySessionId: sessionId && sessionId.includes('b2bLSR') ? enquirySessionId : `b2bLSR${enquirySessionId}`,
      }

      const response = await createUpdateEnquiryService.verifyEnquiry(masterId, sendData);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CREATE_UPDATE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CREATE_UPDATE_ERROR, error));
      return error;
    }
  };
}

export function deleteInvalidParts(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_DELETE_INVALID_FETCHING));
    try {
      const response = await createUpdateEnquiryService.deleteInvalidParts(data);
      dispatch(apiSuccess(CREATE_UPDATE.POST_DELETE_INVALID_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_DELETE_INVALID_ERROR, error));
      return error;
    }
  };
}

export function getDLEmailByRegion(region: string): any {
  return async (dispatch: any) => {
    dispatch(apiStart(FETCH_DL_EMAIL_BY_REGION.FETCH_DL_EMAIL_BY_REGION_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getDLEmailByRegion(region);
      dispatch(apiSuccess(FETCH_DL_EMAIL_BY_REGION.FETCH_DL_EMAIL_BY_REGION_SUCCESS, response))
      return response || [];
    } catch (error) {
      dispatch(apiError(FETCH_DL_EMAIL_BY_REGION.FETCH_DL_EMAIL_BY_REGION_ERROR, error));
      return error
    }
  }
}

export function getRefreshOrderDetailsAPI(customerType?: any, loginId?: any, sapCustomerId?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.REFRESH_DETAILS_API_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getRefreshOrderDetailsAPI(customerType, loginId, sapCustomerId);
      dispatch(apiSuccess(CREATE_UPDATE.REFRESH_DETAILS_API_SUCCESS, response))
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.REFRESH_DETAILS_API_ERROR, error));
      return error
    }
  }
}

export function getTBLPartsAPI() {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.GET_TBL_PART_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getTBLPartsAPI();
      dispatch(apiSuccess(CREATE_UPDATE.GET_TBL_PART_SUCCESS, response))
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.GET_TBL_PART_ERROR, error));
      return error
    }
  }
}

export function verifyEnquiryQueueCheck(customerTierType: any, b2bEnquiryId: any, customerId?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE_QUEUE_CHECK.CREATE_UPDATE_QUEUE_CHECK_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getEnquiryDetailsQueueCheck(customerTierType, b2bEnquiryId, sessionStorage.getItem('webApplicationLoginId'), customerId);
      dispatch(apiSuccess(CREATE_UPDATE_QUEUE_CHECK.CREATE_UPDATE_QUEUE_CHECK_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE_QUEUE_CHECK.CREATE_UPDATE_QUEUE_CHECK_ERROR, error));
      return error;
    }
  };
}

export function verifyQuotationQueueCheck(enquiryId: any, b2bEnquiryId: any, sapCustomerId: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE_QUEUE_CHECK.CREATE_UPDATE_QUEUE_CHECK_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getQuotationDetailsQueueCheck(enquiryId, b2bEnquiryId, sessionStorage.getItem('webApplicationLoginId'), sapCustomerId);
      dispatch(apiSuccess(CREATE_UPDATE_QUEUE_CHECK.CREATE_UPDATE_QUEUE_CHECK_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE_QUEUE_CHECK.CREATE_UPDATE_QUEUE_CHECK_ERROR, error));
      return error;
    }
  };
}

export function getOrderLogs(b2bEnquiryId: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(VERIFIED_ORDER_LOGS.GET_VERIFIED_ORDER_LOGS_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getOrderLogs(b2bEnquiryId);
      dispatch(apiSuccess(VERIFIED_ORDER_LOGS.GET_VERIFIED_ORDER_LOGS_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(VERIFIED_ORDER_LOGS.GET_VERIFIED_ORDER_LOGS_ERROR, error));
      return error;
    }
  };
}

export function getOrderLogsLatestCount(b2bEnquiryId: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(VERIFIED_ORDER_LOGS.GET_VERIFIED_ORDER_LOGS_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getOrderLogsLatestCount(b2bEnquiryId);
      dispatch(apiSuccess(VERIFIED_ORDER_LOGS.GET_VERIFIED_ORDER_LOGS_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(VERIFIED_ORDER_LOGS.GET_VERIFIED_ORDER_LOGS_ERROR, error));
      return error;
    }
  };
}

export function sendEmailWihtoutAnnexurePlaceOrder(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_SEND_EMAIL_WITHOUT_PLACE_ORDER_ANNEXURE_FETCHING));
    try {
      const response = await createUpdateEnquiryService.sendEmailWihtoutAnnexurePlaceOrder(data);
      dispatch(apiSuccess(CREATE_UPDATE.POST_SEND_EMAIL_WITHOUT_PLACE_ORDER_ANNEXURE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_SEND_EMAIL_WITHOUT_PLACE_ORDER_ANNEXURE_ERROR, error));
      return error;
    }
  };
}

export function sendEmailInvalidAnnexureQuantity(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_SEND_EMAIL_ANNEXURE_INVALID_QUANTITY_FETCHING));
    try {
      const response = await createUpdateEnquiryService.sendEmailInvalidAnnexureQuantity(data);
      dispatch(apiSuccess(CREATE_UPDATE.POST_SEND_EMAIL_ANNEXURE_INVALID_QUANTITY_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_SEND_EMAIL_ANNEXURE_INVALID_QUANTITY_ERROR, error));
      return error;
    }
  };
}


export function notifyFSEPricingTeamOrderPlace(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_NOTIFY_PRICING_TIER_FETCHING));
    try {
      const response = await createUpdateEnquiryService.notifyFSEPricingTeamOrderPlace(data);
      dispatch(apiSuccess(CREATE_UPDATE.POST_NOTIFY_PRICING_TIER_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_NOTIFY_PRICING_TIER_ERROR, error));
      return error;
    }
  };
}


export function sendZeroProductsEmail(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.SEND_EMAIL));
    try {
      const response = await createUpdateEnquiryService.sendEmail(data);
      dispatch(apiSuccess(CREATE_UPDATE.SEND_EMAIL_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.SEND_EMAIL_ERROR, error));
      return error;
    }
  };
}

export function sendEmailProcurePart(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.SEND_EMAIL_PROCUREMENTPART_FETCHING));
    try {
      const response = await createUpdateEnquiryService.sendEmailProcurePart(data);
      dispatch(apiSuccess(CREATE_UPDATE.SEND_EMAIL_PROCUREMENTPART_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.SEND_EMAIL_PROCUREMENTPART_ERROR, error));
      return error;
    }
  };
}

export function sendEmailOrderLogs(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.SEND_EMAIL_ORDER_LOGS_FETCHING));
    try {
      const response = await createUpdateEnquiryService.sendEmailOrderLogs(data);
      dispatch(apiSuccess(CREATE_UPDATE.SEND_EMAIL_ORDER_LOGS_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.SEND_EMAIL_ORDER_LOGS_ERROR, error));
      return error;
    }
  };
}

export function cancelEnquiry(customerTierType: any, masterId: any, customerId?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CREATE_UPDATE_FETCHING));
    try {
      let sendData: any = {
        "sessionDetails": {
          "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
          "clientIPAddress": sessionStorage.getItem('clientIp'),
          "loginPassword": "",
          "applicationSecurityKey": "",
          "initialLogonIndicator": "",
          "initialPassword": "",
        },
        customerType: customerTierType && customerTierType.toLowerCase(),
        customerId: (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? customerId : sessionStorage.getItem('customerId')
      }

      if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
        sendData.userRole = sessionStorage.getItem('userType') === 'sre' ? 'SRE' : 'FSE'
      }
      const response = await createUpdateEnquiryService.cancelEnquiry(masterId, sendData);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CREATE_UPDATE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CREATE_UPDATE_ERROR, error));
      return error;
    }
  };
}

export function getEnquiryDetails(customerTierType: any, masterId: any, isOrder: any = false, quotation: any, orderLogRead?: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CREATE_UPDATE_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getEnquiryDetails(customerTierType, masterId, isOrder, quotation, orderLogRead);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CREATE_UPDATE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CREATE_UPDATE_ERROR, error));
      return error;
    }
  };
}
export function getLossSaleReasonList() {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.GET_LOSS_SALE_REASON_LIST_FETCHING));
    try {
      const response = await createUpdateEnquiryService.getLossSaleReason();
      dispatch(apiSuccess(CREATE_UPDATE.GET_LOSS_SALE_REASON_LIST_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.GET_LOSS_SALE_REASON_LIST_ERROR, error));
      return error;
    }
  };
}
export function postLossSaleReasonList(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_LOSS_SALE_REASON_LIST_FETCHING));
    try {
      const response = await createUpdateEnquiryService.postLossSaleReason(data);
      dispatch(apiSuccess(CREATE_UPDATE.POST_LOSS_SALE_REASON_LIST_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_LOSS_SALE_REASON_LIST_ERROR, error));
      return error;
    }
  };
}
export function postConfrimOrder(customerTierType: any, masterId: any, enquirySessionId?: any) {
  let sessionId = enquirySessionId && enquirySessionId.toString();
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CONFIRM_ORDER_API_FETCHING));
    try {
      let sendData: any = {
        "sessionDetails": {
          "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
          "clientIPAddress": sessionStorage.getItem('clientIp'),
          "loginPassword": "",
          "applicationSecurityKey": "",
          "initialLogonIndicator": "",
          "initialPassword": "",
        },
        customerType: customerTierType.toLowerCase(),
        customerId: sessionStorage.getItem('customerId'),
        isTpcDealer: true,
        enquirySessionId: sessionId && sessionId.includes('b2bLSR') ? enquirySessionId : `b2bLSR${enquirySessionId}`,
      }

      const response = await createUpdateEnquiryService.postConfrimOrder(masterId, sendData);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CONFIRM_ORDER_API_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CONFIRM_ORDER_API_ERROR, error));
      return error;
    }
  };
}

export function placeOrder(customerTierType: any, deliveryType: any, masterId: any, isAnnexureEnquiry?: any, hasBypassedCreditCheck?: any, userRole?: any, customerAccountType?: any, userName?: any, userId?: any, enquirySessionId?: any, productsWithBo?: any) {
  let sessionId = enquirySessionId && enquirySessionId.toString();
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.POST_CREATE_UPDATE_FETCHING));
    try {
      let sendData: any = {
        "sessionDetails": {
          "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
          "clientIPAddress": sessionStorage.getItem('clientIp')
        },
        "userName": userName,
        "userId": userId,
        isAnnexureEnquiry: isAnnexureEnquiry ? isAnnexureEnquiry : false,
        hasBypassedCreditCheck : hasBypassedCreditCheck ? hasBypassedCreditCheck : false,
        userRole: userRole,
        customerAccountType: customerAccountType,
        "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
        enquirySessionId: sessionId && sessionId.includes('b2bLSR') && sessionId.length > 6 ? sessionId : sessionId !== null && sessionId.length > 5 ? `b2bLSR${sessionId}` : `b2bLSR${getUniqueTimestamp()}`,
        // enquirySessionId: sessionId && sessionId.includes('b2bLSR') ? enquirySessionId : `b2bLSR${enquirySessionId}`,
        customerType: customerTierType.toLowerCase(),
        customerId: sessionStorage.getItem('customerId'),
        deliveryType: deliveryType === "DLV" ? "Onsite Delivery" : deliveryType === "SELF-PIC" ? "Self Pickup" : "Select",
        productsWithBo: productsWithBo || []
      }

      const response = await createUpdateEnquiryService.placeOrder(masterId, sendData);
      dispatch(apiSuccess(CREATE_UPDATE.POST_CREATE_UPDATE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.POST_CREATE_UPDATE_ERROR, error));
      return error;
    }
  };
}

export function deleteLostSaleReport(customerTierType: any, ids: any, enquirySessionId: any) {
  let sessionId = enquirySessionId && enquirySessionId.toString();
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.DELETE_LOST_SALE_REPORT_FETCHING));
    try {
      let sendData: any = {
        "id": ids,
        enquirySessionId: sessionId && sessionId.includes('b2bLSR') ? enquirySessionId : `b2bLSR${enquirySessionId}`,
        customerType: customerTierType && customerTierType.toLowerCase(),
      }
      const response = await createUpdateEnquiryService.deleteLostSaleReport(sendData);
      dispatch(apiSuccess(CREATE_UPDATE.DELETE_LOST_SALE_REPORT_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(CREATE_UPDATE.DELETE_LOST_SALE_REPORT_ERROR, error));
      return error;
    }
  };
}

export function setEnquiryId(item: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.SET_ENQUIRY_ID, item));
  };
}

export function selectedParts(item: any, estTotal: any, enquiryDataDetails: any) {
  return async (dispatch: any) => {
    let estTotalGrand = {
      selectedParts: item, estPartsTotal: estTotal, enquiryData: enquiryDataDetails
    }
    dispatch(apiStart(SELECTED_PARTS.GET_SELECTED_PARTS_SUCCESS, estTotalGrand))
  }
}

// export function getTechDocPartList(item?: any, partList?: any, enquiryDataDetails?: any) {
//   return async (dispatch: any) => {
//     let techDocPart = {
//       techDocParts: item, partsList: partList, enquiryData: enquiryDataDetails
//     }
//     dispatch(apiStart(TECH_DOC_PARTS.GET_TECH_DOC_PART_SUCCESS, techDocPart))
//   }
// }

export function setOrderLogs(logs: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(CREATE_UPDATE.SET_ORDER_LOGS, logs));
  };
}


export function setCustomerChoosePopup() {
  return { type: CREATE_UPDATE.SET_SHOWPOPUP }
}

export function hideCustomerChoosePopup() {
  return { type: CREATE_UPDATE.SET_HIDEPOPUP }
}

export function saveUserFilter(data:any) {
    return async (dispatch: any) => {
        dispatch(apiStart(CREATE_UPDATE.SET_FILTER_FETCHING));
        try {
            const response = await createUpdateEnquiryService.saveUserFilter(data);
            dispatch(apiSuccess(CREATE_UPDATE.SET_FILTER_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(CREATE_UPDATE.SET_FILTER_ERROR, error));
            return error;
        }
    };
}